import { motion } from "framer-motion";
import { Reveal, ease } from "@/lib/reveal";
import { useLang } from "@/lib/lang";

export default function Framework() {
  const { t } = useLang();
  return (
    <section className="pad section-line" id="framework" data-testid="framework-section">
      <Reveal className="eyebrow">{t.framework.eyebrow}</Reveal>
      <Reveal delay={0.05}>
        <h2 className="big" style={{ maxWidth: 760 }} data-testid="framework-title">{t.framework.title}</h2>
      </Reveal>
      <Reveal delay={0.1}>
        <p className="body" style={{ maxWidth: 700, marginBottom: 64 }}>{t.framework.intro}</p>
      </Reveal>

      <div className="cards" data-testid="framework-cards">
        {t.framework.cards.map((f, i) => (
          <motion.div
            className="card"
            key={i}
            data-testid={`framework-card-${i}`}
            initial={{ opacity: 0, y: 40 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-60px" }}
            transition={{ duration: 0.8, delay: i * 0.12, ease }}
          >
            <div className="cnum">{f.n}</div>
            <h3>{f.title}</h3>
            <p>{f.body}</p>
          </motion.div>
        ))}
      </div>

      <Reveal delay={0.1} className="quotes">
        {t.framework.quotes.map((q, i) => <p key={i}>{q}</p>)}
      </Reveal>
    </section>
  );
}
